import React, {useEffect, useState} from 'react';
import {isEmptyValues, translate, translateV1Alt} from '@src/helpers';
import {Button, Form, OverlayTrigger, Tooltip} from 'react-bootstrap';
import {DATE_FORMAT, DATETIME_FORMAT, QUESTION_TYPE, USER_ACTION} from "@src/types";
import Select from "react-select";
import {useSelector} from "react-redux";
import Datetime from "react-datetime";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCaretDown, faCaretUp, faInfoCircle, faMinus, faPlus} from "@fortawesome/free-solid-svg-icons";
import _ from "lodash-es";
import moment from "moment";
import "react-datetime/css/react-datetime.css";

export const MOMENT_DATETIME_FORMAT = 'YYYY-MM-DD hh:mm a';

interface PRODUCT_TEMPLATE {
  content: string
  id: number
  is_public: number
  name: string
  status: number
  uid: string
}

const ProductTemplateAnswerV2 = ({
                                   action = "" as USER_ACTION,
                                   template: template = {} as PRODUCT_TEMPLATE,
                                   onChange = {} as any,
                                   onSubmit
                                 }: any) => {
  const [formStatus, setFormStatus] = useState({
    processing: false,
    isValid: false,
    message: "",
  });

  const langData = useSelector((state: any) => state.currentLanguage) as any;

  let count = 0;
  const [item, setItem] = useState(template || {} as any)
  const [isTemplateExpand, setTemplateExpand] = useState(true)
  const [isValid, setValid] = useState(false);

  const [questions, setQuestions] = useState({
    selected: {},
    list: [],
  } as any);

  const [list, setList] = useState([] as any)

  const [selected, setSelected] = useState({
    templateId: "" as any,
    fields: "" as any
  } as any)

  const formHandle = {
    onUpdateQuestion: {
      validate: async () => {
        try {
          let p = {...item};
          const keysCheck = ["id", "name", "answer_type", "is_required", "is_public", "value"],
            keys = [...keysCheck, "tooltip"];

          const isValid = _.every(_.map(list, (cef) => {
            let v = _.values(_.pick(cef, keysCheck));
            return !_.some(v, isEmptyValues)
          }));

          if (isValid) {
            let tmp = _.clone(list);
            p.content = JSON.stringify(_.map(tmp, (v) => _.pick(v, keys)));
          }

          if (_.isFunction(onChange)) {
            let tmp = {list, selected};
            onChange(tmp)
          }
        } catch (e) {
          console.error(e)
        }
      },
      onChange: async (e: any, index: number, field: string, type = "" as QUESTION_TYPE) => {
        try {
          let lt = [...list], {target} = e;
          let value: any;

          if (target) value = target?.type === 'checkbox' ? target.checked : target.value;
          else value = e;

          lt[index][field] = value;

          if (moment.isMoment(value)) {
            if (type === QUESTION_TYPE.DATE_PICKER) {
              lt[index][field] = value.format(DATE_FORMAT)
            }

            if (type === QUESTION_TYPE.DATETIME_PICKER) {
              lt[index][field] = value.format(MOMENT_DATETIME_FORMAT)
            }
          }

          setList([...lt])
          setSelected({
              ...selected,
              templateId: selected.templateId,
              fields: [...lt]
            }
          )
          await formHandle.onUpdateQuestion.validate();
        } catch (e) {
          console.error(e)
        }
      },
      onBlur: async (e: any, index: number, field: string, type = "" as QUESTION_TYPE) => {
        try {

          let lt = [...list], {target} = e;
          let value: any;

          if (target) value = target?.type === 'checkbox' ? target.checked : target.value;
          else value = e;

          switch (type) {
            case QUESTION_TYPE.DECIMAL:
              value = parseFloat(value);
              break;
            case QUESTION_TYPE.INTEGER:
              value = parseInt(value);
              break;
            case QUESTION_TYPE.DATE_PICKER:
              value = moment(e).format(DATE_FORMAT);
              break;
            case QUESTION_TYPE.DATETIME_PICKER:
              value = moment(e).format(DATETIME_FORMAT);
              break;
          }

          lt[index][field] = value;
          setList([...lt])
          setSelected({
              ...selected,
              templateId: selected.templateId,
              fields: [...lt]
            }
          )
          await formHandle.onUpdateQuestion.validate();
        } catch (e) {
          console.error(e)
        }
      },
      onChangeFile: async (e: any, index: number, field: string, type = "" as QUESTION_TYPE, ref: any = {}) => {
        try {
          /**
           * Logic handled via storefront
           */
        } catch (e) {
          console.error(e)
        }
      },
      onExpand: async (index: number) => {
        try {
          let cf = list
          cf[index].is_expand = !cf[index].is_expand;
          setQuestions({...questions, ...cf});

        } catch (e) {
          console.error(e)
        }
      },
      onSelectChange: async (selectedOption: any, index: number, field: string, type = "" as QUESTION_TYPE) => {
        try {
          let lt = [...list], {value} = selectedOption;
          lt[index][field] = value;
          setList([...lt])
          setSelected({
              ...selected,
              templateId: selected.templateId,
              fields: [...lt]
            }
          )
          await formHandle.onUpdateQuestion.validate();
        } catch (e) {
          console.error(e)
        }
      }
    },
  }

  const handleItem = (item) => {
    try {
      if (!_.isEmpty(item)) {
        let {id, content, pivot, uid} = item;

        let tmpList: any = [];
        let tmpSelected: any = {}

        if (id) tmpSelected.templateId = id;

        if (content) {
          let t = JSON.parse(content);
          if (_.isArray(t)) {
            tmpList = [..._.map(t, (v: any) => {
              v.answer_type = v.answer_type.toUpperCase();
              v.disabled = (action === USER_ACTION.VIEW);

              if (v.answer_type.toUpperCase() === QUESTION_TYPE.DROPDOWNLIST) {
                if (!_.isEmpty(v.answer_type_content)) v.select = _.map(v.answer_type_content, (o: any, oIdx: number) => {
                  let t: any = {value: "", label: ""};
                  if (_.isObject(o)) {
                    if (_.size(_.head(_.toPairs(o))) === 2) {
                      let tpo: any = _.head(_.toPairs(o));
                      t.value = tpo[0];
                      t.label = tpo[1]
                    }
                  }
                  return t;
                })
              }

              return {...v, is_expand: true}
            })];
          }

          if (pivot) {
            let {content: pivotContent} = pivot

            if (pivotContent) {
              let p = JSON.parse(pivotContent);
              if (p) {
                if (_.isArray(p)) {
                  _.each(p, (v: any) => {
                    let i = _.find(tmpList, (o) => o.id === v.id)
                    i.value = v.value;
                  })
                }
              }
            }

          }
          tmpSelected.fields = [...tmpList];
          setList([...tmpList])
        }
        setSelected({...tmpSelected})
        if (_.isFunction(onChange)) onChange({list: tmpList, selected: tmpSelected})
      }
    } catch (e) {
      console.error(e)
    }
  }

  useEffect(() => {
    (async () => {
      try {
        if (!_.isEqual(item, template)) {
          let {id: templateId, content} = item;
          setItem({...item, ...template});
        }
      } catch (e) {
        console.error(e)
      }
    })()
  }, [template])

  useEffect(() => {
    handleItem(item)
  }, [item])


  return (
    <>
      {!_.isEmpty(item) && <Form noValidate>

          <div className="template-wrapper mt-3">

              <div className="template-header">

                  <Button type="button" variant="outline-success"
                          onClick={(e) => setTemplateExpand(!isTemplateExpand)}
                          className={"bs-height template-expander borderless d-none"}>
                    {!isTemplateExpand
                      ? <FontAwesomeIcon icon={faCaretDown} style={{fontSize: "16px"}}/>
                      : <FontAwesomeIcon icon={faCaretUp} style={{fontSize: "16px"}}/>
                    }
                  </Button>

                  <div>
                    {translate(langData.localize, "LABEL.ADDITIONAL_INFORMATION")}
                  </div>

              </div>

            {!_.size(list) && <div className={"mt-2 mb-2 d-flex flex-column question-container "}
            >
                <div className={"question-fields"}>
                    <Form.Label className={"question-name disabled form-control mb-2"}
                    >
                        <strong>{translate(langData.localize, "LABEL.FIELDS.IS_EMPTY")}</strong>
                    </Form.Label>
                </div>
            </div>}

            {isTemplateExpand && _.size(list) > 0 &&
              list.map((question: any, itemIndex: any) => {
                  let ref = question.ref || React.createRef();
                  return question.is_public
                    ? <div key={`question-${itemIndex}`}
                           className={"mt-2 mb-2 d-flex flex-column question-container "}
                           id={`question-${itemIndex}`}>

                      <div className={"question-fields"}>

                        <Form.Label className={"question-name disabled form-control mb-2"}
                        >
                          <OverlayTrigger
                            overlay={
                              <Tooltip
                                bsPrefix={"fib-bs-tooltip tooltip"}
                                id={`qq-${itemIndex}`}>
                                {translateV1Alt(langData.localize, question.tooltip || question.name)}</Tooltip>
                            }>
                            <FontAwesomeIcon icon={faInfoCircle} className={"mr-1"}/>
                          </OverlayTrigger>

                          {question.name} {question.is_required &&
                            <strong
                                className={"text-red"}>{translate(langData.localize, "LABEL.ASTERISK")}</strong>}
                        </Form.Label>

                        {question.is_expand && <>
                          {(question.answer_type === QUESTION_TYPE.DECIMAL || question.answer_type === QUESTION_TYPE.INTEGER)
                            && <Form.Control className={"form-control "}
                                             disabled={question.disabled}
                                             value={question.value || ""}
                                             type={"text"}
                                             pattern="^-?\d+(\.\d+)?$"
                                             onChange={(e) => formHandle.onUpdateQuestion.onChange(e, itemIndex, 'value', question.answer_type)}
                                             onBlur={(e) => formHandle.onUpdateQuestion.onBlur(e, itemIndex, 'value', question.answer_type)}
                                             placeholder={translate(langData.localize, `LABEL.ANSWER.${_.toUpper(question.answer_type)}`)}/>
                          }
                          {question.answer_type === QUESTION_TYPE.STRING
                            && <Form.Control as={"textarea"} disabled={question.disabled}
                                             className={"form-control "}
                                             value={question.value || ""}
                                             onChange={(e) => formHandle.onUpdateQuestion.onChange(e, itemIndex, 'value', question.answer_type)}
                                             onBlur={(e) => formHandle.onUpdateQuestion.onBlur(e, itemIndex, 'value', question.answer_type)}
                                             placeholder={translate(langData.localize, `LABEL.ANSWER.${_.toUpper(question.answer_type)}`)}/>
                          }

                          {(question.answer_type === QUESTION_TYPE.DATE_PICKER || question.answer_type === QUESTION_TYPE.DATETIME_PICKER)
                            && <Datetime
                                  dateFormat={DATE_FORMAT}
                                  timeFormat={question.answer_type === QUESTION_TYPE.DATETIME_PICKER}
                                  closeOnSelect={true}
                                  value={question.value ? new Date(question.value) : ''}
                                  inputProps={{
                                    autoComplete: "off",
                                    readOnly: true,
                                    className: `form-control ${!question.disabled && "bg-white"}`,
                                    disabled: question.disabled || false,
                                  }}
                                  onChange={(e) => formHandle.onUpdateQuestion.onChange(e, itemIndex, 'value', item.answer_type)}
                              />}

                          {question.answer_type === QUESTION_TYPE.FILE_UPLOAD
                            ?
                            <>
                              {
                                !question.disabled
                                  ? <Form.Control
                                    className={"form-control "}
                                    placeholder={translate(langData.localize, `LABEL.ANSWER.${_.toUpper(question.answer_type)}`)}
                                    type="file"
                                    ref={ref}
                                    disabled={question.disabled}
                                    style={{
                                      lineHeight: "inherit",
                                      borderColor: "#ced4da",
                                      padding: "3px"
                                    }}
                                  />
                                  : null
                              }

                              {
                                question.value ?
                                  <Form.Control className={"form-control "}
                                                disabled={true}
                                                value={question.value || ""}
                                                placeholder={translate(langData.localize, `LABEL.ANSWER.${_.toUpper(question.answer_type)}`)}/>
                                  : ''
                              }
                            </>
                            : ''
                          }
                          {question.answer_type === QUESTION_TYPE.PERCENTAGE
                            &&
                              <Form.Control className={"form-control "} disabled={question.disabled}
                                            value={question.value || ""}
                                            placeholder={translate(langData.localize, `LABEL.ANSWER.${_.toUpper(question.answer_type)}`)}/>
                          }

                          {question.answer_type === QUESTION_TYPE.DROPDOWNLIST
                            && <>
                                  <Select
                                      menuPosition={"fixed"} menuShouldScrollIntoView={true}
                                      isDisabled={question.disabled}
                                      className="basic-single"
                                      classNamePrefix="select"
                                      isSearchable={true}
                                      options={question.select}
                                      value={_.findIndex(question.select, (q: any) => q.value === question.value) !== -1
                                        ? question.select[_.findIndex(question.select, (q: any) => q.value === question.value)]
                                        : ""}
                                  />
                              </>
                          }

                        </>}

                      </div>

                      <div key={"toggle"} className={"question-toggle d-none"}>
                        <Button type="button" variant="outline-success"
                                onClick={() => formHandle.onUpdateQuestion.onExpand(itemIndex)}
                                className={"bs-height"}>
                          {!question?.is_expand
                            ? <FontAwesomeIcon icon={faPlus}/>
                            : <FontAwesomeIcon icon={faMinus}/>
                          }
                        </Button>
                      </div>

                    </div>
                    : <div key={`question-${itemIndex}`}
                           className={"mt-2 mb-2 d-flex flex-column question-container "}
                           id={`question-${itemIndex}`}>
                      <div className={"question-fields"}>
                        <Form.Label className={"question-name disabled form-control mb-2"}
                        >{question.name} {question.is_required &&
                            <strong
                                className={"text-red"}>{translate(langData.localize, "LABEL.ASTERISK")}</strong>}
                        </Form.Label>

                        <Form.Control className={"form-control mb-2"}
                                      value={translate(langData.localize, "LABEL.FIELD.IS_NOT_PUBLIC")}
                                      type={"text"} disabled={true}
                        />

                      </div>
                    </div>
                }
              )}

          </div>
      </Form>}

    </>
  );
}

export default ProductTemplateAnswerV2;
